/* global CSS_CONFIG */
import React from 'react';
import styled from 'styled-components';
import useTranslation from '../hooks/useTranslation';
import InlineMessage from '@ingka/inline-message';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { getCountryDisplayName } from './Form/utils.js';

const InformationContainer = styled(InlineMessage)`
  margin-top: 50px;
`;

const { COUNTRY, LANGUAGE } = CSS_CONFIG;

const country = getCountryDisplayName(LANGUAGE, COUNTRY);

const ShippingInfoBox = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <InformationContainer
      ssrIcon={InformationCircle}
      title={t('spareParts.summary.shipping.title', { country })}
      body={t('spareParts.summary.shipping.info', { country })}
    />
  );
};

export default ShippingInfoBox;
